module.exports = "/static/media/lineto-circular-medium.5b4d0688.woff";